import { useAuth } from 'app/contexts/AuthenticationProvider'
import { RegistrationSteps } from 'EstraSponsor'
import React from 'react'

import { Steps, StepsNav } from '../StepsNav'

type RegistrationStepsNavProps = {
  currentStep: RegistrationSteps
}

export const RegistrationStepsNav: React.FC<RegistrationStepsNavProps> = ({
  currentStep,
}) => {
  const { user } = useAuth()

  // Hide first step if it's not a new sponsorman, but it's editing his data
  // to do that check if a pdf registry file has been uploaded,
  // it means that registration has been completed at least once
  const isRegistrationCompleted = user?.sponsorman.pdf_registry_updated_at

  const registrationSteps: Partial<Record<RegistrationSteps, string>> = {
    ...(!isRegistrationCompleted && { signup: 'SCELTA PASSWORD' }),
    user_data: 'DATI ANAGRAFICI',
    accounting_data: 'DATI CONTABILI',
    documents: 'FIRMA MODULI',
    thank_you: '', // No label, this step just set the stepsNav to completed
  }

  const stepsNumber = isRegistrationCompleted ? 'tre' : 'quattro'

  const title = `La procedura di attivazione del tuo profilo è \n composta da ${stepsNumber} step. Tu sei qui:`

  return (
    <StepsNav
      title={title}
      currentStep={currentStep}
      steps={registrationSteps as Steps}
    ></StepsNav>
  )
}
